module.exports = __webpack_public_path__ + "static/media/zplc-pic@3x.f5c240c9.png";